import { countries } from '~/constants/countries';
import { type State } from '~/types/Address';

const usStates: { [key: string]: State } = {
  AK: { iso: 'AK', name: 'Alaska' },
  AL: { iso: 'AL', name: 'Alabama' },
  AR: { iso: 'AR', name: 'Arkansas' },
  AZ: { iso: 'AZ', name: 'Arizona' },
  CA: { iso: 'CA', name: 'California' },
  CO: { iso: 'CO', name: 'Colorado' },
  CT: { iso: 'CT', name: 'Connecticut' },
  DC: { iso: 'DC', name: 'District of Columbia' },
  DE: { iso: 'DE', name: 'Delaware' },
  FL: { iso: 'FL', name: 'Florida' },
  GA: { iso: 'GA', name: 'Georgia' },
  HI: { iso: 'HI', name: 'Hawaii' },
  IA: { iso: 'IA', name: 'Iowa' },
  ID: { iso: 'ID', name: 'Idaho' },
  IL: { iso: 'IL', name: 'Illinois' },
  IN: { iso: 'IN', name: 'Indiana' },
  KS: { iso: 'KS', name: 'Kansas' },
  KY: { iso: 'KY', name: 'Kentucky' },
  LA: { iso: 'LA', name: 'Louisiana' },
  MA: { iso: 'MA', name: 'Massachusetts' },
  MD: { iso: 'MD', name: 'Maryland' },
  ME: { iso: 'ME', name: 'Maine' },
  MI: { iso: 'MI', name: 'Michigan' },
  MN: { iso: 'MN', name: 'Minnesota' },
  MO: { iso: 'MO', name: 'Missouri' },
  MS: { iso: 'MS', name: 'Mississippi' },
  MT: { iso: 'MT', name: 'Montana' },
  NC: { iso: 'NC', name: 'North Carolina' },
  ND: { iso: 'ND', name: 'North Dakota' },
  NE: { iso: 'NE', name: 'Nebraska' },
  NH: { iso: 'NH', name: 'New Hampshire' },
  NJ: { iso: 'NJ', name: 'New Jersey' },
  NM: { iso: 'NM', name: 'New Mexico' },
  NV: { iso: 'NV', name: 'Nevada' },
  NY: { iso: 'NY', name: 'New York' },
  OH: { iso: 'OH', name: 'Ohio' },
  OK: { iso: 'OK', name: 'Oklahoma' },
  OR: { iso: 'OR', name: 'Oregon' },
  PA: { iso: 'PA', name: 'Pennsylvania' },
  RI: { iso: 'RI', name: 'Rhode Island' },
  SC: { iso: 'SC', name: 'South Carolina' },
  SD: { iso: 'SD', name: 'South Dakota' },
  TN: { iso: 'TN', name: 'Tennessee' },
  TX: { iso: 'TX', name: 'Texas' },
  UT: { iso: 'UT', name: 'Utah' },
  VA: { iso: 'VA', name: 'Virginia' },
  VT: { iso: 'VT', name: 'Vermont' },
  WA: { iso: 'WA', name: 'Washington' },
  WI: { iso: 'WI', name: 'Wisconsin' },
  WV: { iso: 'WV', name: 'West Virginia' },
  WY: { iso: 'WY', name: 'Wyoming' },
};

const usTerritoryStates = {
  AS: { iso: 'AS', name: 'American Samoa' },
  FM: { iso: 'FM', name: 'Micronesia, Federated States of' },
  GU: { iso: 'GU', name: 'Guam' },
  MH: { iso: 'MH', name: 'Marshall Islands' },
  MP: { iso: 'MP', name: 'Northern Mariana Islands' },
  PR: { iso: 'PR', name: 'Puerto Rico' },
  PW: { iso: 'PW', name: 'Palau' },
  UM: { iso: 'UM', name: 'United States Minor Outlying Islands' },
  VI: { iso: 'VI', name: 'Virgin Islands, U.S.' },
};

const usMilitaryStates = {
  AA: { iso: 'AA', name: 'Armed Forces America' },
  AE: { iso: 'AE', name: 'Armed Forces European' },
  AP: { iso: 'AP', name: 'Armed Forces Pacific' },
};

const usMilitaryCities = ['APO', 'FPO', 'DPO'];

const caStates = {
  AB: { iso: 'AB', name: 'Alberta' },
  BC: { iso: 'BC', name: 'British Columbia' },
  MB: { iso: 'MB', name: 'Manitoba' },
  NB: { iso: 'NB', name: 'New Brunswick' },
  NL: { iso: 'NL', name: 'Newfoundland and Labrador' },
  NS: { iso: 'NS', name: 'Nova Scotia' },
  NT: { iso: 'NT', name: 'Northwest Territories' },
  NU: { iso: 'NU', name: 'Nunavut' },
  ON: { iso: 'ON', name: 'Ontario' },
  PE: { iso: 'PE', name: 'Prince Edward Island' },
  QC: { iso: 'QC', name: 'Quebec' },
  SK: { iso: 'SK', name: 'Saskatchewan' },
  YT: { iso: 'YT', name: 'Yukon' },
};

const auStates = {
  ACT: { iso: 'ACT', name: 'Australian Capital Territory' },
  NSW: { iso: 'NSW', name: 'New South Wales' },
  NT: { iso: 'NT', name: 'Northern Territory' },
  QLD: { iso: 'QLD', name: 'Queensland' },
  SA: { iso: 'SA', name: 'South Australia' },
  TAS: { iso: 'TAS', name: 'Tasmania' },
  VIC: { iso: 'VIC', name: 'Victoria' },
  WA: { iso: 'WA', name: 'Western Australia' },
};

const states: Record<string, Record<string, State>> = {
  [countries.AU.iso2]: auStates,
  [countries.CA.iso2]: caStates,
  [countries.US.iso2]: { ...usStates, ...usTerritoryStates, ...usMilitaryStates },
};

export default states;

export { usMilitaryCities, usMilitaryStates, usStates, usTerritoryStates };
